import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { Model, Receivable } from 'src/app/core/interfaces/receivable';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { ReceivableService } from '../receivable.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from 'src/app/core/resources/utils';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { CatalogItem } from 'src/app/core/interfaces/catalogItem';
import { Patterns } from 'src/app/core/resources/patterns';
import { Fmt } from 'src/app/core/messages/fmt';

@Component({
  selector: 'app-receivable-create',
  templateUrl: './receivable-create.component.html',
  styleUrls: ['./receivable-create.component.scss'],
  providers: [Model, Patterns]
})
export class ReceivableCreateComponent implements OnInit {
  validate = '';
  receivableTypes: CatalogItem[] = [];
  receivableReasons: string[] = [];
  form: FormGroup;
  public reasonOption: FormControl = new FormControl('');
  public previousReceivableType: string = 'servicio';
  constructor(
    public dialogRef: MatDialogRef<ReceivableCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogParams: any,
    public ModelReceivable: Model,
    public formBuilder: FormBuilder,
    public SnackBarService: SnackBarService,
    public receivableService: ReceivableService,
    public spinner: NgxSpinnerService,
    public utils: Utils,
    private patterns: Patterns
  ) {    
    // Crear formulario manualmente para evitar problemas con ReactiveForm
    this.form = this.formBuilder.group({
      receivableType: [null, Validators.required],
      cargoConsecutive: ['', Validators.required],
      whoReports: this.formBuilder.group({
        documentTypeId: ['', Validators.required],
        documentTypeName: ['', Validators.required],
        document: ['', [
          Validators.required,
          Validators.pattern(this.patterns.ONLY_NUMBERS.source),
          Validators.minLength(3),
          Validators.maxLength(15)
        ]],
        name: ['', Validators.required],
      }),
      amountInitial: ['', Validators.required],
      reason: ['', Validators.required],
      installments: [1, [Validators.required, Validators.min(1)]]
    });
  }

  async ngOnInit() {
    await this.getReceivableTypes();
    await this.getReceivableReasons();
    if (this.receivableTypes && this.receivableTypes.length > 0) this.form.get('receivableType').setValue(this.receivableTypes[0]);
    if (this.receivableReasons && this.receivableReasons.length > 0) {
      this.form.get('reason').setValue(this.receivableReasons[0]);
      this.reasonOption.setValue(this.receivableReasons[0]);
    }
  }

  async getReceivableTypes(){
    try {
      this.form.get('receivableType').disable();
      const response = await this.receivableService.getReceivableTypes().toPromise();
      if (response && response.catalog && response.catalog.length) this.receivableTypes = response.catalog.filter(type => type.name === 'servicio');
      else this.receivableTypes = []
    } catch (error) {
      this.receivableTypes = [];
      console.error("error getting receivable types", error);
    } finally {
      this.form.get('receivableType').enable();
    }
  }

  async getReceivableReasons(){
    try {
      this.reasonOption.disable();
      const response = await this.receivableService.getReceivableReasons().toPromise();
      if (response && response.catalog && response.catalog.length) this.receivableReasons = response.catalog.map(receivableReason => receivableReason.name);
      else this.receivableReasons = []
    } catch (error) {
      this.receivableReasons = [];
      console.error("error getting receivable reasons", error);
    } finally{
      this.reasonOption.enable();
    }
  }

  onChangeReceivableType($event: MatSelectChange){
    const cargoConsecutiveControl = this.form.get('cargoConsecutive');
    if ($event.value && ($event.value.name === 'préstamos' || $event.value.name === 'otro')){
      cargoConsecutiveControl.clearValidators();
      if(this.previousReceivableType === 'servicio') this.form.get('reason').setValue('');
    }
    else {
      cargoConsecutiveControl.setValidators([Validators.required]);
      this.form.get('reason').setValue(this.reasonOption.value !== 'Otra' ? this.reasonOption.value : '');
    }
    cargoConsecutiveControl.updateValueAndValidity();
    this.previousReceivableType = $event.value.name;
  }

  onChangeReceivableReason($event: MatSelectChange){
    if ($event.value && $event.value !== 'Otra') this.form.get('reason').setValue($event.value);
    else this.form.get('reason').setValue('');
  }

  onSubmit() {
    this.validate = "touched";
    if (this.form.invalid) {
      if (this.utils.errorMessagesCustomized(this.form.get('receivableType'), "tipo de cartera")) { }
      if (this.utils.errorMessagesCustomized(this.form.get('cargoConsecutive'), "id del servicio asociado")) { }
      else if (this.utils.errorMessagesCustomized(this.form.get('amountInitial'), "monto inicial de la cartera")) { }
      else if (this.utils.errorMessagesCustomized(this.form.get('installments'), "número de cuotas", null, null, 1)) { }
      else if (this.utils.errorMessagesCustomized(this.form.get('reason'), "razón de la cartera")) { }
      else if (this.utils.errorMessagesCustomized(this.form.get('whoReports.documentTypeName'), "tipo de identificación")) { }
      else if (this.utils.errorMessagesCustomized(this.form.get('whoReports.document'), "n° de identificación", 3, 15)) { }
      else if (this.utils.errorMessagesCustomized(this.form.get('whoReports.name'), "nombre")) { }
      else this.SnackBarService.openSnackBar(FormMessages.GENERAL_ERROR_DEFAULT, undefined, "alert");
      return;
    } else if (!this.form.get('whoReports.documentTypeName').value || !this.form.get('whoReports.name').value) {
      this.SnackBarService.openSnackBar("Por favor seleccione un usuario válido en el campo n° de identificacion", undefined, "alert")
      return;
    }
    const numberAmountInitial = parseInt(this.form.get('amountInitial').value);
    this.form.get('amountInitial').setValue(numberAmountInitial);
    this.spinner.show();
    this.receivableService.createReceivable(this.form.getRawValue()).subscribe({
      next: (res: Receivable) => {
        this.spinner.hide();
        this.SnackBarService.openSnackBar(Fmt.string(FormMessages.SUCCESS_RECEIVABLE, res.consecutive), undefined, "success");
        this.dialogRef.close({ state: true });
      },
      error: (error) => {
        this.spinner.hide();
        this.SnackBarService.openSnackBar(error && error.error && error.error.message ? error.error.message : ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
